/** Short random id, used to keep SVG gradient ids collision-free across multiple funnels on a page. */
export function generateRandomIdString(prefix = ''): string {
    return Math.random().toString(36).replace('0.', prefix);
}
